import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router';
import { useHistory } from 'react-router-dom';
import { ContentContainer } from '../../components/ContentContainer';
import { GenericToolbar } from '../../components/GenericToolbar/GenericToolbar';
import { pushAppRoute } from '../../data/domain/route-manager';
import { AppRoute, AppRoutes } from '../../routes';
import { PxChildDeviceProfileData } from '../../components/DeviceProfile/PxChildProfileData';
import { useDeviceDetails } from '../../data/DataProviders/DeviceDetailsProvider';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { DataIndicators } from '../../components/DataIndicators';
import { DevicePropertiesDetails } from '../../types/device';
import { isDataLoaded } from '../../types';


export const PxChildDeviceProfile: React.FC = () => {
    const selectedOrganization = useSelectedOrganizationData();
    const history = useHistory();
    const currentAppRoute = useCurrentAppRoute();
    const pxChildDeviceDetails = useDeviceDetails();

    const [childDeviceData, setChildDeviceData] = useState<DevicePropertiesDetails | null>(null);
    const [headerDeviceName, setHeaderDeviceName] = useState('');
    const currentPage = currentAppRoute.type === 'PxChildDeviceProfile' ? 'PxChildDeviceProfile' : '';

    useEffect(() => {
        if (isDataLoaded(pxChildDeviceDetails)) {
            setChildDeviceData(pxChildDeviceDetails.value);
            setHeaderDeviceName(pxChildDeviceDetails.value.name);
        }
    }, [pxChildDeviceDetails]);

    const backRoute = (
        orgId: string,
        locationId: string,
        siteId: string,
        deviceId: string,
        childDeviceId: string
    ): AppRoute =>
        currentPage === 'PxChildDeviceProfile'
            ? { type: 'PxDeviceProfile', orgId: orgId, locationId: locationId, siteId: siteId, deviceId: deviceId }
            : {
                type: 'PxChildDeviceProfile',
                deviceId: deviceId,
                locationId: locationId,
                orgId: orgId,
                siteId: siteId,
                childDeviceId: childDeviceId,
            };

    return (
        <>
            {isRecordFound(selectedOrganization) &&
                'locationId' in currentAppRoute &&
                'deviceId' in currentAppRoute &&
                'siteId' in currentAppRoute &&
                'childDeviceId' in currentAppRoute && (
                    <>
                        <GenericToolbar
                            showBackButton
                            backButtonOnClick={(): void => {
                                pushAppRoute(
                                    history,
                                    backRoute(
                                        selectedOrganization.value.id,
                                        currentAppRoute.locationId,
                                        currentAppRoute.siteId,
                                        currentAppRoute.deviceId,
                                        currentAppRoute.childDeviceId
                                    )
                                );
                            }}
                            title={currentPage === 'PxChildDeviceProfile' ? headerDeviceName : ''}
                            subtitle={currentPage === 'PxChildDeviceProfile' ? 'Device Profile' : headerDeviceName}
                        />

                        <DataIndicators
                            emptyIcon="Devices"
                            emptyMessage={'No Device Data'}
                            errorMessage={'No Device Data'}
                            data={pxChildDeviceDetails}
                            isEmpty={false}
                        />
                        <ContentContainer>
                            <Switch>
                                <Route exact path={AppRoutes.PxChildDeviceProfile}>
                                        <PxChildDeviceProfileData
                                            pxChildDeviceDetails={childDeviceData}
                                            backAppRoute={backRoute(
                                                selectedOrganization.value.id,
                                                currentAppRoute.locationId,
                                                currentAppRoute.siteId,
                                                currentAppRoute.deviceId,
                                                currentAppRoute.childDeviceId
                                            )}
                                        />
                                </Route>
                            </Switch>
                        </ContentContainer>
                    </>
                )}
        </>
    );
};
